import { Component, inject } from '@angular/core';
import { EnvService } from '@core-mkt/services/env/env.service';

@Component({
  selector: 'environment-notice',
  templateUrl: './environment-notice.component.html',
  styleUrls: ['./environment-notice.component.scss'],
  standalone: true,
})
export class EnvironmentNoticeComponent {
  private readonly envService = inject(EnvService);
  private readonly env = this.envService.get;

  readonly isNonProduction = this.env.envMode === 'stage' || this.env.envMode === 'dev';
  readonly productionUrl = this.env.brandConfig.url
    ? `https://${this.env.brandConfig.url.replace(/^https?:\/\//, '')}`
    : '';
}
